import React, { forwardRef } from 'react';
import Image from 'next/image';
import cn from 'classnames';

import styles from './styles.module.scss';

const SurveyImage = forwardRef<HTMLImageElement, {
  src: string,
  width: number,
  height: number,
  className?: string,
}>(({ src, width, height, className }, ref) => {
  return (
    <div ref={ref} className={cn(styles.image, className)}>
      <Image src={src} width={width} height={height} priority={true} quality={50} layout="responsive" />
    </div>
  );
});

export default SurveyImage;